import React, { useEffect } from 'react';
import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  message,
  Upload,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import {
  CREATE_ERROR,
  EDIT_ERROR,
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { StoryGroupService } from 'services/StoryGroupService';
import { requiredRule } from 'utils/forms/validationRules';
import { normFile } from 'utils/files';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

function StoryGroupForm({ isActive, onClose, onSuccess, initialValues }) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (initialValues) {
      const { title, title_kz, thumbnail, thumbnail_kz, position } =
        initialValues;

      form.setFieldsValue({
        title,
        title_kz,
        thumbnail: thumbnail ? [{ name: thumbnail }] : undefined,
        thumbnail_kz: thumbnail_kz ? [{ name: thumbnail_kz }] : undefined,
        position,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    const formData = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      if (!value) {
        formData.append(key, '');
        return;
      }

      if (key === 'thumbnail' || key === 'thumbnail_kz') {
        if (value[0]?.originFileObj) {
          formData.append(key, value[0]?.originFileObj);
          return;
        }

        if (value[0]) {
          formData.append(key, value[0].name);
          return;
        }

        formData.append(key, '');
        return;
      }

      formData.append(key, value);
    });

    if (isEditing) {
      handleUpdate(formData, initialValues.id);
    } else {
      handleCreate(formData);
    }
  };

  const handleCreate = async (data) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isCreated = await StoryGroupService.createStoryGroup(data);

      if (isCreated) {
        handleConfirm();
        message.success(SUCCESS_CREATE);
      }
    } catch (err) {
      message.error(CREATE_ERROR);
    } finally {
      hide();
    }
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isUpdated = await StoryGroupService.updateStoryGroup(data, id);

      if (isUpdated) {
        handleConfirm();
        message.success(SUCCESS_UPDATE);
      }
    } catch (err) {
      message.error(EDIT_ERROR);
    } finally {
      hide();
    }
  };

  const handleConfirm = () => {
    onClose();
    onSuccess();
    form.resetFields();
  };

  return (
    <Drawer
      title={
        isEditing ? 'Редактирование групп истории' : 'Создание групп истории'
      }
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="position" label="Порядок" rules={[requiredRule]}>
          <InputNumber
            controls={false}
            placeholder="Введите порядок"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item name="title" label="Заголовок">
          <Input placeholder="Введите заголовок" allowClear />
        </Form.Item>

        <Form.Item name="title_kz" label="Заголовок (каз.)">
          <Input placeholder="Введите заголовок (каз.)" allowClear />
        </Form.Item>

        <Form.Item
          name="thumbnail"
          label="Медиа"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload accept=".png" maxCount={1} beforeUpload={() => false}>
            <Button icon={<UploadOutlined />}>Загрузить</Button>
          </Upload>
        </Form.Item>

        <Form.Item
          name="thumbnail_kz"
          label="Медиа (каз)"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload accept=".png" maxCount={1} beforeUpload={() => false}>
            <Button icon={<UploadOutlined />}>Загрузить</Button>
          </Upload>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { StoryGroupForm };
